import CCD from '../../containers/Apps/CCD';

export const CCDRoutes = [
	{
		...CCD,
		path: '/apps/download',
		pathRegex: '/apps/download/:productId?/:pageType?',
		titleId: 'app.document.title.apps',
	},
	{
		...CCD,
		path: '/',
		pathRegex: '/:locale?/apps/download/:productId?/:pageType?',
		titleId: 'app.document.title.apps',
	},
];
